var Utils = require('core-helpers/utils.js');
var ScriptLoader = require('helpers/script-loader.js');
var ThirdPartyService = require('third-party/third-party-service.js');
var TrustpilotService = require('trustpilot/trustpilot-service.js');
const reqwest = require('reqwest/reqwest.min');
const _ = require('underscore');

/**
 * Trustpilot
 */
(function(root, doc, undefined) {

    'use strict';

    const sectionWrapper = Utils.getById('js-trustpilot-redesign-section');
    const widgetWrapper = Utils.getById('js-trustpilot-widget__wrapper');
    const widgetLoader = Utils.getById('js-trustpilot-widget__loader');
    const starsStringTemplate = Utils.getById('js-trustpilot__rating-stars-string');
    const ratingCountTemplate = Utils.getById('js-trustpilot__rating-count-string');
    const reviewsCountTemplate = Utils.getById('js-trustpilot__reviews-count');
    const starsTemplate = Utils.getById('js_trustpilot-widget__stars-container');

    let trustpilotData = { rating: 0, stars: 0, starString: '', starsImg: '', reviewsCount: 0 };

    const getTranslation = function(key) {
        return BUSUU_TRANSLATIONS[key] || 'NOT FOUND';
    };

    const isVendorDisabled = function() {
        return ThirdPartyService.isVendorDisabled();
    };

    const fetchBusinessInfo = () => {
        return TrustpilotService.getBusinessInfo()
            .then(data => {
                trustpilotData = _.extendOwn({}, trustpilotData, {
                    rating: data.trustScore,
                    stars: data.stars,
                    reviewsCount: data.numberOfReviews.total
                });
                return data;
            });
    };

    const fetchStarsString = () => {
        return TrustpilotService.getStarsString(trustpilotData.stars).then((data) => {
            const translatedStarsString = getTranslation(`${data.string.toUpperCase()}`);
            trustpilotData = _.extendOwn({}, trustpilotData, { starString: translatedStarsString });
            return data;
        });
    };

    const printRating = () => {
        // translations
        const translatedRatingCount = getTranslation('X_OUT_OF_10').replace('%s', trustpilotData.rating);
        const translatedReviewsCount = getTranslation('SEE_ALL_X_REVIEWS_ON').replace('%s', trustpilotData.reviewsCount);
        const starsCountClass = `trustpilot__stars-${trustpilotData.stars}`;

        Utils.addClass(starsTemplate, starsCountClass);

        Utils.setText(starsStringTemplate, trustpilotData.starString);
        Utils.setText(ratingCountTemplate, translatedRatingCount);
        Utils.setText(reviewsCountTemplate, translatedReviewsCount);

        // Show rating template and hide loader
        Utils.show(widgetWrapper);
        Utils.hide(widgetLoader);
    };

    const fetchTrustPilotRatingData = () => {

        const onError = (error) => {
            Utils.hide(sectionWrapper);
        };
        fetchBusinessInfo().then(fetchStarsString).then(printRating).catch(onError).done();
    };

    const init = () => {

        if (isVendorDisabled()) {
            return false;
        }
        if (sectionWrapper) {
            fetchTrustPilotRatingData();
        }

        const trustpilot = Utils.getById('trustpilot');
        if (!trustpilot) {
            return false;
        }

        const trustpilotTemplate = trustpilot.getAttribute('data-template-id');

        // Inject it! (delayed after load event)
        ScriptLoader.add(trustpilotTemplate, 'trustpilot');
    };

    init();

})(window, document);
